import { render, staticRenderFns } from "./DetailsTopBar.vue?vue&type=template&id=72e40f5c&"
import script from "./DetailsTopBar.vue?vue&type=script&lang=js&"
export * from "./DetailsTopBar.vue?vue&type=script&lang=js&"
import style0 from "./DetailsTopBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports